<template>
  <b-card
    class="list-card"
    header-bg-variant="transparent"
    header-class="d-flex align-items-center pt-0 border-0 "
    body-class="pt-0"
    footer-border-variant="transparent"
    footer-bg-variant="transparent"
    footer-class="d-flex align-items-center justify-content-end border-0"
  >
    <template #header>
      <div
        class="text-primary cursor-pointer position-absolute"
        style="font-size: 18px; left: 2px; top: -2px"
        @click="$emit('deleteElement')"
      >
        <i class="mdi mdi-close-circle-outline" @click.stop="deleteItem(item.id)" />
      </div>
      <slot name="profile"/>
      <div class="name font-weight-bolder">{{title}}</div>
      <slot name="button"/>
    </template>
      <b-row>
        <b-col cols="12">
          <h-e-rectangle
            :title="rectMiddle"
            class=" d-flex justify-content-center border-0 "
            style="background-color: #f3f3f9; color:black "
          />
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="6">
          <h-e-rectangle
            :title="rectLeft"
            class="task p-3 d-flex justify-content-center border-0"
            bg-color="tertiary"
            color-full 
            rounded 
          />

        </b-col>
        <b-col cols="6">
          <h-e-rectangle
            :title="rectRight"
            class="task p-3 d-flex justify-content-center border-0"
            bg-color="tertiary"
            color-full
            rounded
          />
        </b-col>
      </b-row>

    <template #footer>
     <slot name="buttonFooter"></slot>
    </template>
  </b-card>
</template>

<script>
import {confirmModal} from "@/helpers/swalModal";

export default {
  
  props: {

    item: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    rectMiddle: {
      type: String,
      default: "",
    },
    rectLeft: {
      type: String,
      default: "",
    },
    rectRight: {
      type: String,
      default: "",
    },
    
    type: {
      type: String,
      default: "",
    },
  },
  
  methods: {
    async deleteItem(id) {
      const result = await confirmModal('Supprimer', `Effacer ${this.type} effacera les étapes et les tâches associés`)
      if (result.value) {
        this.$emit('deleteItem', id)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.list-card {
  flex-basis: 425px;
  font-size: 12px;
  border-radius: 34px;
  height: 279px;
  padding: 13px;
  .name {
    color: #465bfd;
  }
  .step {
    background-color: #f3f3f9;
  }
  .task {
    background-color: rgba(128, 232, 255, 0.2);
    color: #81e8ff;
  }
  .buttons {
    display: flex;
    position: absolute;
    top: 18px;
    right: 33px;
    align-items: center;
    .action-rounded {
      margin-left: 15px;
    }
  }
}
</style>